// import React, { useState, useEffect } from 'react';
// import {
//   Box, Button, TextField, Typography, Stack, Alert
// } from '@mui/material';
// import axios from 'axios';
// import { Link, useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import BASE_API_URL from '../apis/index';

// const RegisterForm = () => {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: '',
//     designation: '',
//     company: '',
//     mobile: '',
//     email: '',
//     password: '',
//     profileImage: null
//   });

//   const [mobileOtp, setMobileOtp] = useState('');
//   const [emailOtp, setEmailOtp] = useState('');
//   const [mobileVerified, setMobileVerified] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [otpStep, setOtpStep] = useState({ mobileSent: false, emailSent: false });
//   const [otpTimer, setOtpTimer] = useState(0);
//   const [message, setMessage] = useState({ type: '', text: '' });

//   const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

//   // ⏱️ Start OTP timer
//   useEffect(() => {
//     if (otpTimer > 0) {
//       const timer = setInterval(() => {
//         setOtpTimer(prev => prev - 1);
//       }, 1000);
//       return () => clearInterval(timer);
//     }
//   }, [otpTimer]);

//   const formatTimer = () => {
//     const min = Math.floor(otpTimer / 60);
//     const sec = otpTimer % 60;
//     return `${min}:${sec < 10 ? '0' : ''}${sec}`;
//   };

//   const showMessage = (type, text) => setMessage({ type, text });

//   // 📱 Send Mobile OTP
//   const sendMobileOtp = async () => {
//     try {
//       const res = await axios.post(`${BASE_API_URL}/api/auth/send-otp/mobile`, { mobile: form.mobile });
//       console.log(res.data);
//       setOtpStep({ ...otpStep, mobileSent: true });
//       setOtpTimer(120);
//       showMessage('success', 'Mobile OTP sent successfully');
//     } catch (err) {
//       showMessage('error', err.response?.data?.error || 'Failed to send mobile OTP');
//     }
//   };

//   // ✅ Verify Mobile OTP
//   const verifyMobileOtp = async () => {
//     try {
//       await axios.post(`${BASE_API_URL}/api/auth/verify-otp/mobile`, {
//         mobile: form.mobile,
//         otp_code: mobileOtp
//       });
//       setMobileVerified(true);
//       showMessage('success', 'Mobile verified successfully');
//     } catch (err) {
//       showMessage('error', err.response?.data?.error || 'Incorrect OTP');
//     }
//   };

//   // 📧 Send Email OTP
//   const sendEmailOtp = async () => {
//     try {
//       const res = await axios.post(`${BASE_API_URL}/api/auth/send-otp/email`, { email: form.email });
//       console.log(res.data);
//       setOtpStep({ ...otpStep, emailSent: true });
//       setOtpTimer(120);
//       showMessage('success', 'Email OTP sent successfully');
//     } catch (err) {
//       showMessage('error', err.response?.data?.error || 'Failed to send email OTP');
//     }
//   };

//   // ✅ Verify Email OTP
//   const verifyEmailOtp = async () => {
//     try {
//       await axios.post(`${BASE_API_URL}/api/auth/verify-otp/email`, {
//         email: form.email,
//         otp_code: emailOtp
//       });
//       setEmailVerified(true);
//       showMessage('success', 'Email verified successfully');
//     } catch (err) {
//       showMessage('error', err.response?.data?.error || 'Incorrect OTP');
//     }
//   };

//   // Handle file change
//   const handleFileChange = e => {
//     setForm({ ...form, profileImage: e.target.files[0] });
//   };

//   // 📝 Submit Register
//   const handleSubmit = async e => {
//     e.preventDefault();
//     if (form.password !== form.confirmPassword) {
//       showMessage('error', 'Passwords do not match');
//       return;
//     }

//     try {
//       const fd = new FormData();
//       fd.append('name', form.name);
//       fd.append('company', form.company);
//       fd.append('designation', form.designation);
//       fd.append('mobile', form.mobile);
//       fd.append('email', form.email);
//       fd.append('password', form.password);
//       if (form.profileImage) fd.append('profile_image', form.profileImage);

//       const res = await axios.post(`${BASE_API_URL}/api/auth/register`, fd, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });

//       if (res.data.status === 'ok') {
//         showMessage('success', 'Registration successful!');
//         setTimeout(async () => {
//           try {
//             const res = await axios.post(`${BASE_API_URL}/api/auth/login`, {
//               email: form.email,
//               password: form.password,
//             });
//             localStorage.setItem('authToken', res.data.token);
//             setTimeout(() => navigate('/dashboard'), 1000);
//           } catch (err) {
//             showMessage('error', err.response?.data?.error || 'Login failed');
//           }
//         }, 2000);
//       }
//     } catch (err) {
//       showMessage('error', err.response?.data?.error || 'Registration failed');
//     }
//   };

//   return (
//     <RegisterWrapper>
//       <h2 className='text-center txt_color_primary'>Register to SupplyChain</h2>

//       {message.text && (
//         <Alert severity={message.type} sx={{ mb: 2 }}>{message.text}</Alert>
//       )}

//       <form onSubmit={handleSubmit}>
//         <Stack spacing={2}>
//           <TextField name="name" label="Full Name" value={form.name} onChange={handleChange} required />
//           <TextField name="company" label="Company" value={form.company} onChange={handleChange} required />
//           <TextField name="designation" label="Designation" value={form.designation} onChange={handleChange} required />
//           <TextField type="file" inputProps={{ accept: 'image/*' }} onChange={handleFileChange} helperText="Upload your profile picture" required />

//           {/* Mobile */}
//           <TextField
//             name="mobile"
//             label="Mobile Number"
//             value={form.mobile}
//             onChange={handleChange}
//             disabled={mobileVerified}
//             helperText={
//               mobileVerified
//                 ? '✅ Mobile verified successfully!'
//                 : 'Mobile number will be verified by OTP'
//             }
//             required
//           />

//           {/* Mobile OTP Input */}
//           {!mobileVerified && otpStep.mobileSent && (
//             <TextField
//               label="Enter Mobile OTP"
//               value={mobileOtp}
//               onChange={e => setMobileOtp(e.target.value)}
//               inputProps={{ maxLength: 6 }}
//             />
//           )}

//           {/* Mobile Buttons */}
//           {!mobileVerified && (
//             <Box display="flex" justifyContent="space-between" alignItems="center">
//               {otpStep.mobileSent ? (
//                 <>
//                   <Button onClick={verifyMobileOtp} variant="outlined" color='warning'>Verify Mobile OTP</Button>
//                   <Typography variant="body2">⏱ {formatTimer()}</Typography>
//                 </>
//               ) : (
//                 <Button onClick={sendMobileOtp} variant="outlined" color="warning" disabled={!form.mobile}>
//                   Send Mobile OTP
//                 </Button>
//               )}
//             </Box>
//           )}

//           {/* Email Flow */}
//           {mobileVerified && (
//             <>
//               <TextField
//                 name="email"
//                 label="Email"
//                 value={form.email}
//                 onChange={handleChange}
//                 disabled={emailVerified}
//                 helperText={emailVerified ? '✅ Email verified successfully!' : ''}
//                 required
//               />

//               {/* Email OTP Input */}
//               {!emailVerified && otpStep.emailSent && (
//                 <TextField
//                   label="Enter Email OTP"
//                   value={emailOtp}
//                   onChange={e => setEmailOtp(e.target.value)}
//                   inputProps={{ maxLength: 6 }}
//                 />
//               )}

//               {/* Email Buttons */}
//               {!emailVerified && (
//                 <Box display="flex" justifyContent="space-between" alignItems="center">
//                   {otpStep.emailSent ? (
//                     <>
//                       <Button onClick={verifyEmailOtp} variant="contained" color='warning'>Verify Email OTP</Button>
//                       <Typography variant="body2">⏱ {formatTimer()}</Typography>
//                     </>
//                   ) : (
//                     <Button onClick={sendEmailOtp} variant="outlined" color='warning' disabled={!form.email}>
//                       Send Email OTP
//                     </Button>
//                   )}
//                 </Box>
//               )}
//             </>
//           )}

//           {/* Password Fields */}
//           {mobileVerified && emailVerified && (
//             <>
//               <TextField
//                 name="password"
//                 label="Password"
//                 type="password"
//                 value={form.password}
//                 onChange={handleChange}
//                 required
//               />
//               <TextField
//                 name="confirmPassword"
//                 label="Confirm Password"
//                 type="password"
//                 value={form.confirmPassword}
//                 onChange={handleChange}
//                 required
//                 error={form.confirmPassword && form.password !== form.confirmPassword}
//                 helperText={form.confirmPassword && form.password !== form.confirmPassword ? 'Passwords do not match' : ''}
//               />
//               <Button type="submit" variant="contained" color="Warning" className='w-100' disabled={form.password !== form.confirmPassword}>
//                 Register
//               </Button>
//             </>
//           )}
//         </Stack>
//       </form>

//       <p className="mt-3 text-center border-top pt-4 mt-4">
//         Already have an account?
//         <Link to="/login" className="text-decoration-none txt_color_secondary ms-2">
//           Login here
//         </Link>
//       </p>
//     </RegisterWrapper>
//   );
// };

// export default RegisterForm;

// const RegisterWrapper = styled.div`
//   max-width: 500px;
//   margin: 100px auto;
//   min-height: 62vh;
// `


import React, { useState, useEffect } from 'react';
import {
  Box, Button, TextField, Typography, Stack, Alert,
  Autocomplete
} from '@mui/material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BASE_API_URL from '../apis/index';
import countries from '../utils/countries';

const RegisterForm = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    designation: '',
    company: '',
    countryCode: '+91',
    mobile: '',
    email: '',
    password: '',
    confirmPassword: '',
    profileImage: null
  });

  const [mobileOtp, setMobileOtp] = useState('');
  const [emailOtp, setEmailOtp] = useState('');
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [otpStep, setOtpStep] = useState({ mobileSent: false, emailSent: false });
  const [otpTimer, setOtpTimer] = useState(0);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [submitting, setSubmitting] = useState(false); // 🔹 new state for submit disable

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  // Official email validation (block free email providers)
  const isOfficialEmail = (email) => {
    const freeDomains = [
      'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com', 'protonmail.com', 'zoho.com', 'icloud.com', 'yandex.com'
    ];
    const domain = email.split('@')[1]?.toLowerCase();
    return domain && !freeDomains.includes(domain);
  };

  // ⏱️ Start OTP timer
  useEffect(() => {
    if (otpTimer > 0) {
      const timer = setInterval(() => {
        setOtpTimer(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [otpTimer]);

  const formatTimer = () => {
    const min = Math.floor(otpTimer / 60);
    const sec = otpTimer % 60;
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  };

  const showMessage = (type, text) => setMessage({ type, text });

  // 📱 Send Mobile OTP
  const sendMobileOtp = async () => {
    try {
      const res = await axios.post(`${BASE_API_URL}/api/auth/send-otp/mobile`, { mobile: form.mobile, code: form.countryCode });
      console.log(res.data);
      setOtpStep({ ...otpStep, mobileSent: true });
      setOtpTimer(120);
      showMessage('success', 'Mobile OTP sent successfully');
    } catch (err) {
      showMessage('error', err.response?.data?.error || 'Failed to send mobile OTP');
    }
  };

  // ✅ Verify Mobile OTP
  const verifyMobileOtp = async () => {
    try {
      await axios.post(`${BASE_API_URL}/api/auth/verify-otp/mobile`, {
        mobile: form.mobile,
        otp_code: mobileOtp
      });
      setMobileVerified(true);
      showMessage('success', 'Mobile verified successfully');
    } catch (err) {
      showMessage('error', err.response?.data?.error || 'Incorrect OTP');
    }
  };

  // 📧 Send Email OTP
  const sendEmailOtp = async () => {
    if (!isOfficialEmail(form.email)) {
      showMessage('error', 'Please enter your official company email (no Gmail/Yahoo/etc.)');
      return;
    }
    try {
      const res = await axios.post(`${BASE_API_URL}/api/auth/send-otp/email`, { email: form.email });
      console.log(res.data);
      setOtpStep({ ...otpStep, emailSent: true });
      setOtpTimer(120);
      showMessage('success', 'Email OTP sent successfully');
    } catch (err) {
      showMessage('error', err.response?.data?.error || 'Failed to send email OTP');
    }
  };

  // ✅ Verify Email OTP
  const verifyEmailOtp = async () => {
    try {
      await axios.post(`${BASE_API_URL}/api/auth/verify-otp/email`, {
        email: form.email,
        otp_code: emailOtp
      });
      setEmailVerified(true);
      showMessage('success', 'Email verified successfully');
    } catch (err) {
      showMessage('error', err.response?.data?.error || 'Incorrect OTP');
    }
  };

  // Handle file change
  const handleFileChange = e => {
    setForm({ ...form, profileImage: e.target.files[0] });
  };

  // 📝 Submit Register
  const handleSubmit = async e => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      showMessage('error', 'Passwords do not match');
      return;
    }

    setSubmitting(true); // 🔹 disable button
    try {
      const fd = new FormData();
      fd.append('name', form.name);
      fd.append('company', form.company);
      fd.append('designation', form.designation);
      fd.append('mobile', form.mobile);
      fd.append('email', form.email);
      fd.append('password', form.password);
      if (form.profileImage) fd.append('profile_image', form.profileImage);

      const res = await axios.post(`${BASE_API_URL}/api/auth/register`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (res.data.status === 'ok') {
        showMessage('success', 'Registration successful!');
        setTimeout(async () => {
          try {
            const res = await axios.post(`${BASE_API_URL}/api/auth/login`, {
              email: form.email,
              password: form.password,
            });
            localStorage.setItem('authToken', res.data.token);
            setTimeout(() => navigate('/dashboard'), 1000);
          } catch (err) {
            showMessage('error', err.response?.data?.error || 'Login failed');
          }
        }, 2000);
      }
    } catch (err) {
      showMessage('error', err.response?.data?.error || 'Registration failed');
    } finally {
      setSubmitting(false); // 🔹 re-enable button after response
    }
  };

  return (
    <RegisterWrapper>
      <h2 className='text-center txt_color_primary'>Register to SupplyChain</h2>

      {message.text && (
        <Alert severity={message.type} sx={{ mb: 2 }}>{message.text}</Alert>
      )}

      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField name="name" label="Full Name" value={form.name} onChange={handleChange} required />
          <TextField name="company" label="Company" value={form.company} onChange={handleChange} required />
          <TextField name="designation" label="Designation" value={form.designation} onChange={handleChange} required />
          <TextField type="file" inputProps={{ accept: 'image/*' }} onChange={handleFileChange} helperText="Upload your profile picture" required />

          {/* Mobile */}
          <div className='d-flex gap-2'>
            <Autocomplete
              className="w-30"
              options={countries}
              getOptionLabel={(option) => option ? `${option.code} ${option.phone}` : ''}
              renderOption={(props, option) => ( <li {...props}> {option.code} {option.phone} </li> )}
              renderInput={(params) => ( <TextField {...params} label={<> Country Code <span style={{ color: 'red' }}>*</span> </>} />)}
              value={countries.find((c) => c.phone === form.countryCode) || null}
              onChange={(event, newValue) => { setForm({...form, countryCode: newValue?.phone || '+91'}) }}
              isOptionEqualToValue={(option, value) => option.phone === value.phone }
            />

            <TextField
              name="mobile"
              label="Mobile Number"
              value={form.mobile}
              onChange={handleChange}
              disabled={mobileVerified}
              helperText={
                mobileVerified
                  ? '✅ Mobile verified successfully!'
                  : 'Mobile number will be verified by OTP'
              }
              required
              className='w-70'
            />
          </div>

          {/* Mobile OTP Input */}
          {!mobileVerified && otpStep.mobileSent && (
            <TextField
              label="Enter Mobile OTP"
              value={mobileOtp}
              onChange={e => setMobileOtp(e.target.value)}
              inputProps={{ maxLength: 6 }}
            />
          )}

          {/* Mobile Buttons */}
          {!mobileVerified && (
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {otpStep.mobileSent ? (
                <>
                  <Button onClick={verifyMobileOtp} variant="outlined" color='warning'>Verify Mobile OTP</Button>
                  <Typography variant="body2">⏱ {formatTimer()}</Typography>
                </>
              ) : (
                <Button onClick={sendMobileOtp} variant="outlined" color="warning" disabled={!form.mobile}>
                  Send Mobile OTP
                </Button>
              )}
            </Box>
          )}

          {/* Email Flow */}
          {mobileVerified && (
            <>
              <TextField
                name="email"
                label="Official Email"
                value={form.email}
                onChange={handleChange}
                disabled={emailVerified}
                helperText={emailVerified ? '✅ Email verified successfully!' : 'Enter only official company email'}
                required
              />

              {/* Email OTP Input */}
              {!emailVerified && otpStep.emailSent && (
                <TextField
                  label="Enter Email OTP"
                  value={emailOtp}
                  onChange={e => setEmailOtp(e.target.value)}
                  inputProps={{ maxLength: 6 }}
                />
              )}

              {/* Email Buttons */}
              {!emailVerified && (
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  {otpStep.emailSent ? (
                    <>
                      <Button onClick={verifyEmailOtp} variant="contained" color='warning'>Verify Email OTP</Button>
                      <Typography variant="body2">⏱ {formatTimer()}</Typography>
                    </>
                  ) : (
                    <Button onClick={sendEmailOtp} variant="outlined" color='warning' disabled={!form.email}>
                      Send Email OTP
                    </Button>
                  )}
                </Box>
              )}
            </>
          )}

          {/* Password Fields */}
          {mobileVerified && emailVerified && (
            <>
              <TextField
                name="password"
                label="Password"
                type="password"
                value={form.password}
                onChange={handleChange}
                required
              />
              <TextField
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                value={form.confirmPassword}
                onChange={handleChange}
                required
                error={form.confirmPassword && form.password !== form.confirmPassword}
                helperText={form.confirmPassword && form.password !== form.confirmPassword ? 'Passwords do not match' : ''}
              />
              <Button
                type="submit"
                variant="contained"
                color="warning"
                className='w-100'
                disabled={form.password !== form.confirmPassword || submitting}
              >
                {submitting ? 'Please wait...' : 'Register'}
              </Button>
            </>
          )}
        </Stack>
      </form>

      <p className="mt-3 text-center border-top pt-4 mt-4">
        Already have an account?
        <Link to="/login" className="text-decoration-none txt_color_secondary ms-2">
          Login here
        </Link>
      </p>
    </RegisterWrapper>
  );
};

export default RegisterForm;

const RegisterWrapper = styled.div`
  max-width: 500px;
  margin: 100px auto;
  min-height: 62vh;
`;
